export const SET_SEARCH_DELETED = 'SET_SEARCH_DELETED';
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM';
export const INCREMENT_PAGE = 'INCREMENT_PAGE';
export const INCREMENT_SKIP = 'INCREMENT_SKIP';
export const RESET_OFFSET = 'RESET_OFFSET';

interface SetSearchDeletedAction {
  type: typeof SET_SEARCH_DELETED;
  payload: boolean;
}

interface SetSearchTermAction {
  type: typeof SET_SEARCH_TERM;
  payload: string;
}

interface IncrementPageAction {
  type: typeof INCREMENT_PAGE;
}

interface IncrementSkipAction {
  type: typeof INCREMENT_SKIP;
}

interface ResetOffsetAction {
  type: typeof RESET_OFFSET;
}

export type actions =
  | SetSearchDeletedAction
  | SetSearchTermAction
  | IncrementPageAction
  | IncrementSkipAction
  | ResetOffsetAction;
